import React, { useEffect, useLayoutEffect, useRef } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import NotFound from "./pages/NotFound";
import ProjectDetailsSheet from "./components/ProjectDetailsSheet";
import ProjectsPage from "./pages/ProjectsPage";

const ScrollManager: React.FC = () => {
  const location = useLocation();
  const navType = useNavigationType();
  const positions = useRef<Map<string, number>>(new Map());
  const prevKey = useRef<string | null>(null);

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    const key = prevKey.current;
    if (key) {
      positions.current.set(key, window.scrollY);
    }
    prevKey.current =
      (location as any).key ||
      location.pathname + location.search + location.hash;
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    const key =
      (location as any).key ||
      location.pathname + location.search + location.hash;

    if (location.hash) {
      const id = location.hash.slice(1);
      let attempts = 0;
      const maxAttempts = 40; 
      const interval = 50;

      const tryScrollToHash = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "start" });
          return;
        }
        if (attempts < maxAttempts) {
          attempts++;
          window.setTimeout(tryScrollToHash, interval);
        }
      };

      tryScrollToHash();
      return;
    }

    if (navType === "POP") {
      const y = positions.current.get(key) ?? 0;
      window.scrollTo({ top: y, left: 0, behavior: "auto" });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search, location.hash, navType]);

  return null;
};

export default function AppContent() {
  return (
    <div className="app-wrapper">
      <ScrollManager />
      <Navbar />
      <main
        id="main"
        className="content"
        tabIndex={-1}
        role="main"
        aria-live="polite"
      >
        <Routes>
          <Route path="/" element={<Home />} />
            <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:id" element={<ProjectDetailsSheet />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
